const updateDocumentByDocName = async (collectionRef, docName, updatingObject) => {
  await collectionRef.doc(docName).update(updatingObject);
};
export default updateDocumentByDocName;
